<div class="tc-modal">
  <header class="tc-head">
    <h1>Tokens / <span class="gold">credits</span></h1>
    <button type="button" class="tc-close" (click)="close()" aria-label="Close">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="M6 6l12 12M18 6 6 18" stroke-linecap="round" />
      </svg>
    </button>
  </header>

  <p class="tc-lede">
    Monthly tokens refresh with your plan. Purchased and bonus tokens stay until you use them.
    World credits generate a map.
  </p>

  <section class="tc-balances" aria-label="Current balance">
    <div class="tc-stat">
      <span class="v">{{ monthly }}</span>
      <span class="k">Monthly</span>
    </div>
    <div class="tc-stat">
      <span class="v">{{ bonus }}</span>
      <span class="k">Paid / bonus</span>
    </div>
    <div class="tc-stat">
      <span class="v">{{ worldCredits }}</span>
      <span class="k">World credits</span>
    </div>
  </section>

  @if (!isLoading && tokenPacks?.length > 0) {
    <div class="purchase-section mt-3">
      <h3 class="text-center text-white fw-bold mb-3 purchase-title text-uppercase">Purchase</h3>
      <div class="cards-container">
        @for (product of tokenPacks; track product) {
          <div class="purchase-card" [class.is-busy]="buyingPackId === product.id" (click)="buyProduct(product)">
            <div class="card-inner">
              @if (product.image) {
                <div class="package-image-wrapper mb-2">
                  <img [src]="product.image" [alt]="product.name" class="package-image">
                </div>
              }
              <h5 class="fw-bold">{{ product.name }}</h5>
              @if (isWorldCredit(product)) {
                <p class="small mb-0">{{ product.tokens }} World Credit{{ product.tokens === 1 ? '' : 's' }}</p>
              } @else {
                <p class="small mb-1">{{ product.tokens }} Tokens</p>
              }
            </div>
            <div class="price-tag fw-bold">{{ buyingPackId === product.id ? 'Opening checkout…' : '$' + product.price }}</div>
          </div>
        }
      </div>
    </div>
  }

  <section class="tc-history">
    <h2>History</h2>

    <div class="tc-history-panel">
      <div class="tc-cols" aria-hidden="true">
        <span>Date</span>
        <span>Action</span>
        <span class="num">Monthly</span>
        <span class="num">Paid / bonus</span>
        <span class="num">World</span>
      </div>

      @if (isLoading) {
        <div class="tc-history-body">
          <p class="tc-empty">Loading history…</p>
        </div>
      }

      @if (!isLoading && history.length === 0) {
        <div class="tc-history-body">
          <p class="tc-empty">No token activity yet.</p>
        </div>
      }

      @if (!isLoading && history.length > 0) {
        <div class="tc-history-body">
          @for (item of history; track item) {
            <div class="tc-row">
              <span class="date">{{ item.created_at | date: 'dd MMM yyyy' }}</span>
              <span class="src" [title]="item.reference_id || item.source">{{ item.source }}</span>
              <span class="num">{{ formatDelta(item.breakdown?.monthly_recurring) }}</span>
              <span class="num">{{ formatDelta(item.breakdown?.bonus) }}</span>
              <span class="num">{{ formatDelta(item.breakdown?.world_credits) }}</span>
            </div>
          }
        </div>
      }
    </div>
  </section>
</div>
